<section class="tech-blog">
  <div class="heading-container">
    <div class="title desktop" [innerHTML]="heading"></div>
    <div class="title mobile" [innerHTML]="heading"></div>
  </div>

  <div class="blog-container">
    <ng-container *ngFor="let item of blogList">
      <a
        href="{{ item.blogLink }}"
        aria-label="{{ item.blogTitle }}"
        rel="nofollow noopener"
        target="_blank"
        class="blog"
      >
        <!-- blog image cover -->
        <picture>
          <source srcset="{{ item.blogImageWebP }}" type="image/webp" />
          <source srcset="{{ item.blogImage  }}" type="" />
          <img
            class="blog-cover"
            src="{{ item.blogImage }}"
            alt="{{ item.blogAlt }}"
            width="358"
            height="auto"
            loading="lazy"
          />
        </picture>

        <!-- blog-topic -->
        <div class="blog-topic" [innerHTML]="item.blogTitle"> </div>

        <!-- blog content -->
        <div class="blog-content" [innerHTML]="item.blogContent"> </div>

        <!-- blog content -->
        <div class="read-more"> {{ readMore }} <i class="fas fa-angle-right"></i> </div>
      </a>
    </ng-container>
  </div>
</section>
